
import TableList from "@components/templates/tablelist";
import { HttpBillImportDetailList, HttpBillImportDetailExport,HttpReProcessBilling, HttpNoNeedBilling } from "@/service/fedex";
import { mapGetters } from "vuex";
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpBillImportDetailList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateBillimportdetail",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.$router.push({
                        name: 'fedexUpdateBillimportdetail',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data',{defaultValue:'导入数据'}),
                        width: 460,
                        showFooter: false,
                        data: { templateId: this.id },
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierBillImport/associateOrder",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs("/static/template/FedEx_billimportdetail2.xlsx", {}, {
                                executor: 'download',
                                type: 'url'
                            });
                        },
                        on:{
                            "on-success":()=>{
                                this.$emit('on-close')
                            }
                        }
                    }
                    break;
                case 'reprocess':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { ids: params },
                        title: this.$t('global.common.reprocess',{defaultValue:'重处理'}),
                        ajaxRequest: HttpReProcessBilling
                    };
                    break
                case 'noprocess':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { ids: params },
                        title: this.$t('global.common.noprocess',{defaultValue:'无需处理'}),
                        ajaxRequest: HttpNoNeedBilling
                    };
                    break
                case 'export':
                    this.handleWebfs(HttpBillImportDetailExport, this.formData, 'download')
                    break;
                case 'costimpott':

                    let urls = `https://${global.envPrefix}bi.onepinnovate.com/home/report/board?args={"__orgId__":"${this.formData.search.EQ_organizationId || []}","billing_account":"${this.formData.search.EQ_account || []}","id":260}`

                    window.open(this.handleHostname(urls))
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [{
                label: this.$t('fbb.alloment.query_detail',{defaultValue:'查看详情'}),
                show: true,
                params: id,
                operate: 'query'
            },{
                label: this.$t('global.common.operation_edit',{defaultValue:'编辑'}),
                show: status == 'ERROR',
                params: id,
                operate: 'edit'
            }]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceList','getCarrierManageList','getSelfmanageorgList', 'getServiceAllList', 'getCarrierServiceAllList', 'getCarrierAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.b2c.associated_order',{defaultValue:'关联订单'}),
                    operate: "import",
                    theme: "primary",
                },
                {
                    name: this.$t('fbb.alloment.muti_export',{defaultValue:'批量导出'}),
                    operate: "export",
                    theme: "info",
                },
                {
                    name: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                    operate: "reprocess",
                    more:true,
                    batch:true,
                },
                {
                    name: this.$t('fbb.alloment.noprocess', { defaultValue: "无需处理" }),
                    operate: "noprocess",
                    more:true,
                    batch:true,
                },
                {
                    name: this.$t('fbb.accountmanage.cost', { defaultValue: "成本" }) + this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "costimpott",
                    more:true,
                },
            ]
        },
        billingStatusList() {
            return [
                { label: this.$t('fbb.fedex.nocharging',{defaultValue:'未计费'}), value: 'nocharging' },
                { label: this.$t('fbb.fedex.charginged',{defaultValue:'已计费'}), value: 'charginged' },
                { label: this.$t('fbb.fedex.chargingerror',{defaultValue:'计费异常'}), value: 'chargingerror' },

            ]
        },
        SearchsData() {
            return [
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag: 'vInput',
                    key: 'EQ_invoiceNo',
                    show: true,
                },
                {
                    label: this.$t('fbb.fedex.import_date',{defaultValue:'导入日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    default: this.handleDateRange().join(' ~ '),
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },

                {
                    label: this.$t('fbb.alloment.taskNo',{defaultValue:'任务编号'}),
                    tag: 'vInput',
                    key: 'CN_taskNo',
                    more: true,
                },
                {
                    label: this.$t('fbb.bill.logistics_products',{defaultValue:'物流产品'}),
                    // label: "物流产品",
                    tag: 'vSelect',
                    key: 'EQ_groupName',
                    more: true,
                    options: this.getCarrierAllList.map(item=>{
                        return {
                            value:item.label,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'}),
                    label: this.$t('fbb.bill.service_code',{defaultValue:'承运商服务'}),
                    tag: 'Select',
                    key: 'EQ_carrierServiceCode',
                    more: true,
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedex.soucessystem',{defaultValue:'来源系统'}),
                    tag: 'vSelect',
                    key: 'EQ_sourceSystem',
                    more: true,
                    options: [
                        {value:'fbb',label:this.$t('global.common.fbb',{defaultValue:'云仓'}) },
                        {value:'bizarkCloudShipping',label:'Bizark Cloud Shipping'},
                        {value:'UN_KNOW',label:this.$t('fbb.bill.unknown',{defaultValue:'未知'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.product_channel.type',{defaultValue:'类型'}),
                    tag: 'vSelect',
                    key: 'EQ_billType',
                    more: true,
                    options: [
                        {value:'addCost',label:this.$t('fbb.fedex.extracost',{defaultValue:'附加费'}) },
                        {value:'otherCost',label:this.$t('fbb.fedex.othercost',{defaultValue:'未识别'}) },
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    tag: 'vSelect',
                    key: 'EQ_status',
                    more: true,
                    options: [
                        {value:'NORMAL',label:this.$t('fbb.fedex.normalpush',{defaultValue:'未推送结算'})},
                        {value:'ERROR',label:this.$t('fbb.headlogistics.exception',{defaultValue:'异常'}) },
                        {value:'PUSH',label:this.$t('fbb.fedex.allreadypush',{defaultValue:'已推送结算'}) },
                        {value:'NO_NEED_BILLING',label:this.$t('global.common.noprocess',{defaultValue:'无需处理'}) },
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.organization',{defaultValue:'组织'}),
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                    tag: 'vInput',
                    key: 'EQ_account',
                },

            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: this.$t('global.common.actions',{defaultValue:'操作'}),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('fbb.fedex.soucessystem',{defaultValue:'来源系统'}),
                    // key: 'sourceSystem',
                    render:(h,{row})=>{
                        switch(row.sourceSystem){
                            case 'fbb': return this.$t('global.common.fbb',{defaultValue:'云仓'}) ; break;
                            case 'UN_KNOW': return this.$t('fbb.bill.unknown',{defaultValue:'未知'}); break;
                            default: return 'Bizark Cloud Shipping'; break;
                        }
                    }
                },
                {
                    title: this.$t('fbb.bill.organization',{defaultValue:'组织'}),
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId),
                },
                {
                    title:this.$t('fbb.bill.task_number',{defaultValue:'任务编号'}),
                    key:'taskNo'
                },
                {
                    title: this.$t('fbb.bill.logistics_products',{defaultValue:'物流产品'}),
                    // title: '物流产品',
                    key: 'groupName',
                    render: (h, {row}) => { return <div>{row.groupName || '--'}</div>}
                },
                {
                    // title: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'}),
                    title: this.$t('fbb.bill.service_code',{defaultValue:'承运商服务'}),
                    key: 'carrierServiceCode',
                    render: (h, {row}) => { return <div>{row.carrierServiceCode || '--'}</div>}
                },
                {
                    title: this.$t('fbb.fedex.zonecode',{defaultValue:'分区'}),
                    key: 'zoneCode',
                },
                {
                    title: 'Tracking NO',
                    key: 'trackingNo',
                },
                {
                    title: this.$t('global.common.status',{defaultValue:'状态'}),
                    render: (h, { row }) => {
                        switch (row.status) {
                            case "NORMAL": return <div>{this.$t('fbb.fedex.normalpush',{defaultValue:'未推送结算'})}</div>; break;
                            case "ERROR": return <div class="color-error">{this.$t('fbb.headlogistics.exception',{defaultValue:'异常'})}</div>; break;
                            case "PUSH": return <div>{this.$t('fbb.fedex.allreadypush',{defaultValue:'已推送结算'})}</div>; break;
                            case "NO_NEED_BILLING": return <div>{this.$t('global.common.noprocess',{defaultValue:'无需处理'})}</div>; break;
                        }
                    }
                },
                {
                    title: this.$t('erp.product_channel.type',{defaultValue:'类型'}),
                    key: 'billType',
                    render: (h, { row }) => {
                        switch (row.billType) {
                            case "addCost": return <div>{this.$t('fbb.fedex.extracost',{defaultValue:'附加费'})}</div>; break;
                            case "otherCost": return <div class="color-error">{this.$t('fbb.fedex.othercost',{defaultValue:'未识别'})}</div>; break;
                        }
                    }
                },
                {
                    title: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                    key: 'account',
                },
                {
                    title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    key: 'invoiceNo',
                },
                {
                    title: this.$t('fbb.costmanage.exception_tip',{defaultValue:'异常信息'}),
                    key: 'errorMessage',
                },
                {
                    title: this.$t('fbb.fedex.import_time',{defaultValue:'导入时间'}),
                    key: 'createdAt',
                },
            ];
        },

    },

};
